// Navbar Script Start
let openNav = document.querySelector(".ham-wrapper");
let navList = document.getElementById("mySidenav");
openNav.addEventListener("click", function () {
    navList.classList.toggle("open");
});

let heroToggle = document.querySelector(".hero-slider-image");
let heroToggle1 = document.querySelector(".hero-slider-image-1");
let heroToggle2 = document.querySelector(".hero-slider-image-2");
let heroToggle3 = document.querySelector(".hero-slider-image-3");
let heroImage = document.querySelector(".main-hero-image");
// Check if the elements are present before adding event listeners
if (heroToggle && heroToggle1 && heroToggle2 && heroToggle3 && heroImage) {
    heroToggle.addEventListener("click", () => {
        heroImage.src = "{{ asset('/images/cafe/burger-1-min.webp') }}";
        heroImage.style.width = "595px";
        heroImage.style.height = "464px";
        heroImage.style.left = "1rem";
    });

    heroToggle1.addEventListener("click", () => {
        heroImage.src = "{{ asset('/images/cafe/pizza-hero.webp') }}";
        heroImage.style.width = "465px";
        heroImage.style.height = "464px";
        heroImage.style.left = "5rem";
    });

    heroToggle2.addEventListener("click", () => {
        heroImage.src = "{{ asset('/images/cafe/fries-1-min.webp') }}";
        heroImage.style.width = "300px";
        heroImage.style.height = "464px";
        heroImage.style.left = "10rem";
    });

    heroToggle3.addEventListener("click", () => {
        heroImage.src = "{{ asset('/images/cafe/pizza-hero.webp') }}";
        heroImage.style.width = "435px";
        heroImage.style.height = "464px";
        heroImage.style.left = "6rem";
    });
}

let wedding = document.querySelector(".wedding");
let anniversaires = document.querySelector(".anniversaires");
let corporate = document.querySelector(".corporate");
let privateParties = document.querySelector(".private-parties");
let servicesImage = document.querySelector(".services-image");

// Check if functions are present
if (wedding && anniversaires && corporate && privateParties && servicesImage) {
    wedding.addEventListener("click", () => {
        servicesImage.src =
            "https://images.pexels.com/photos/2487438/pexels-photo-2487438.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1";
    });

    anniversaires.addEventListener("click", () => {
        servicesImage.src =
            "https://images.pexels.com/photos/735869/pexels-photo-735869.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1";
    });

    corporate.addEventListener("click", () => {
        servicesImage.src =
            "https://images.unsplash.com/photo-1616734755909-bb016ce64930?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80";
    });

    privateParties.addEventListener("click", () => {
        servicesImage.src =
            "https://images.unsplash.com/photo-1524824267900-2fa9cbf7a506?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80";
    });
}

// If you wish to write some custom code please place this file at the bottom.
import "./custom";
